import { isRunningLocally } from "./util";

export const AMPLITUDE_API_KEY = isRunningLocally()
  ? "71c527100cdf001f715cd99d06c9785f"
  : "b3adbe8c2bf10c2e61e9e52928434e25";

export const SENTRY_DSN =
  "https://eb42fb3f2e6fde272901098f8bcbfb36@o4510778844381184.ingest.us.sentry.io/4510778849558528";

export const GMAPS_SRC =
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyAZsGtjD9t01NfV2j9mT-7v4EJFi0VaNIM&callback=initStreetView";

export const BASE_URL_DEV = "http://127.0.0.1:8000";
export const BASE_URL_DEV_VM = "https://api-dev.luminorrisk.com";
export const BASE_URL_PROD = "https://api.luminorrisk.com";
